import { type ReactNode, createContext, useContext, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type NumbersLayerStore } from 'pages/settings/pages/numbers/store/numbersLayerStore'
import { TextEnableLandlineStore } from 'pages/settings/pages/numbers/pages/TextEnableLandline/store/TextEnableLandlineStore'

const TextEnableLandlineStepsContext = createContext<TextEnableLandlineStore | null>(null)

export const useTextEnableLandlineStepsContext = () => {
  const context = useContext(TextEnableLandlineStepsContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with TextEnableLandlineStepsContext'
    )

  return context
}

export const TextEnableLandlineStepsProvider = ({
  numbersLayerStore,
  children,
}: {
  numbersLayerStore: NumbersLayerStore
  children: ReactNode
}) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new TextEnableLandlineStore(numbersLayerStore, entities), [])

  return (
    <TextEnableLandlineStepsContext.Provider value={store}>
      {children}
    </TextEnableLandlineStepsContext.Provider>
  )
}
